import apiClient from '../client';
import type { ActivityLog, CreateActivityLogRequest } from '../../types';

const activityLogService = {
  getByOperation: async (farmOperationId: string) => {
    const res = await apiClient.get<ActivityLog[]>(`/activity-logs/operation/${farmOperationId}`);
    return res.data;
  },

  create: async (data: CreateActivityLogRequest) => {
    const res = await apiClient.post<ActivityLog>('/activity-logs', data);
    return res.data;
  },

  update: async (id: string, data: CreateActivityLogRequest) => {
    const res = await apiClient.put<ActivityLog>(`/activity-logs/${id}`, data);
    return res.data;
  },

  remove: async (id: string) => {
    await apiClient.delete(`/activity-logs/${id}`);
  },
};

export default activityLogService;
